import Icon from "hardcover-ui/components/Icon";
import faBookmark from "icons/duotone/bookmark.svg";
import Heading from "hardcover-ui/components/Heading";
import UserBooksByStatusTopPreviewView from "./UserBooksByStatusTopPreview/UserBooksByStatusTopPreviewView";
import { UserBookSerializersUserBookStatusList, UserSerializersUserByline } from "types/serializers";

export default function ProfileBooksByStatus({
  user,
  lists,
}: {
  user: UserSerializersUserByline;
  lists: UserBookSerializersUserBookStatusList[];
}) {
  return (
    <section className="space-y-4">
      <Heading level={2} size="md">
        <Icon icon={faBookmark} size="md" className="mr-2" />
        <span>{user.name}'s Books by Status</span>
      </Heading>
      <UserBooksByStatusTopPreviewView user={user} lists={lists} />
    </section>
  );
}
